import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
export default function pick(object, keys) {
  return _reduceInstanceProperty(keys).call(keys, function (obj, key) {
    if (object && Object.prototype.hasOwnProperty.call(object, key)) {
      obj[key] = object[key];
    }
    return obj;
  }, {});
}